import "./Form01.css";

const Form01 = () => {
  return (
    <form action="https://formsubmit.co/..." method="POST" className="Form01">
      <p className="eyebrow green">Contact</p>
      <h2>Get in touch with us.</h2>

      <div>
        <label htmlFor="name"> Your name: </label>
        <input type="text" id="name" name="name" placeholder="Your name..." />
      </div>
      <div>
        <label htmlFor="contact"> Contact details: </label>
        <input
          type="text"
          id="contact"
          name="contact"
          placeholder="Your contact details..."
        />
      </div>
      <div>
        <label htmlFor="message"> Your message: </label>
        <textarea
          name="message"
          id="message"
          placeholder="Any additional details? "
        ></textarea>
      </div>

      <button className="btn-3" type="submit">
        SEND NOW
      </button>
    </form>
  );
};

export default Form01;
